import React, { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with an "eye" toggle on the right edge to reveal/hide.
 * Drop-in replacement for `<input type="password" ... />` — accepts all
 * standard input props (including data-testid for the input itself).
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "gps-input", testIdToggle, ...inputProps },
  ref,
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={show ? "text" : "password"}
        autoComplete={inputProps.autoComplete || "current-password"}
        {...inputProps}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testIdToggle}
        className="absolute top-1/2 right-2 -translate-y-1/2 grid place-items-center w-7 h-7 rounded text-mute hover:text-white focus:outline-none focus:ring-1 focus:ring-cyan-400/50"
        tabIndex={-1}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
